// @ts-strict-ignore
import React, { useMemo } from 'react'
import { CollectionItem } from 'mytours-read-common'
import { IonGrid } from '@ionic/react'
import MenuListItem from './MenuListItem'
import { ionHistory } from '../../../navigation'

import './styles/menuList.less'

interface Props {
	activePageId: number
	list: CollectionItem[]
	navigateToItem: (id: number) => void
}

const MenuList: React.FC<Props> = props => {
	const isActive = (id: number): boolean => {
		const activeId = (ionHistory.location?.state as any)?.activeMenuId || props.activePageId
		return id === activeId
	}

	const renderRow = useMemo<JSX.Element[] | null>(() => {
		const { list } = props

		if (!list) {
			return null
		}

		return list.map((item: CollectionItem, index: number) => (
			<MenuListItem
				item={item}
				isActive={isActive(item.id)}
				onSelect={() => props.navigateToItem(item.id)}
				key={index}
			/>
		))
	}, [props.list])

	return <IonGrid className="menu-list-wrapper">{renderRow}</IonGrid>
}

export default MenuList
